import {transformErrorResponse} from 'store/api';
import type {MergeSuggestion, MergeSuggestionDto} from './types';
import {ebsApi} from '../../store/ebsApi';

const mergeSuggestionsApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getMergeSuggestions: build.query<
      MergeSuggestion[],
      Pick<MergeSuggestion, 'type'>,
      MergeSuggestionDto[]
    >({
      query: params => ({
        url: '/merge-suggestions',
        method: 'GET',
        params: params,
      }),
      providesTags: (result = []) =>
        result.map(mergeSuggestion => ({
          type: 'MergeSuggestions' as const,
          id: mergeSuggestion.id,
        })),
      transformErrorResponse,
    }),
    getMergeSuggestionByTypeSourceIdAndTargetId: build.query<
      MergeSuggestion,
      Pick<MergeSuggestion, 'type' | 'sourceId' | 'targetId'>,
      MergeSuggestionDto
    >({
      query: params => ({
        url: '/merge-suggestions/id',
        method: 'GET',
        params: params,
      }),
      transformErrorResponse,
    }),
    markMergeSuggestionAsProcessed: build.mutation<void, string>({
      query: id => ({
        url: `/merge-suggestions/${id}/processed`,
        method: 'POST',
      }),
      invalidatesTags: (_, __, id) => [
        {
          type: 'MergeSuggestions' as const,
          id: id,
        },
      ],
      transformErrorResponse,
    }),
  }),
});

export const {
  useGetMergeSuggestionsQuery,
  useMarkMergeSuggestionAsProcessedMutation,
  useGetMergeSuggestionByTypeSourceIdAndTargetIdQuery,
} = mergeSuggestionsApi;
